/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Create_Dialog_DescriptionInputs */

const en_users_create_dialog_description = /** @type {(inputs: Users_Create_Dialog_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cognito will email the user an invitation with a temporary password.`)
};

const pt_br2_users_create_dialog_description = /** @type {(inputs: Users_Create_Dialog_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Cognito enviará um convite por e-mail com senha temporária.`)
};

/**
* | output |
* | --- |
* | "Cognito will email the user an invitation with a temporary password." |
*
* @param {Users_Create_Dialog_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_create_dialog_description = /** @type {((inputs?: Users_Create_Dialog_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Create_Dialog_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_create_dialog_description(inputs)
	return pt_br2_users_create_dialog_description(inputs)
});